'use client';

import type { Dispatch, SetStateAction } from 'react';
import type { UrlType } from '~/model/GlobalTypes';
import { useEffect, useState } from 'react';
import Lightbox from 'react-image-lightbox';

export const PicturesGallery = ({
  isOpen,
  setIsOpen,
  picturesList,
  picturesListFallback = picturesList,
  photoIndex,
  setPhotoIndex,
}: PicturesGalleryProps) => {
  const [list, setList] = useState(picturesList);

  useEffect(() => {
    if (picturesList?.length)
      setList(picturesList);
  }, [picturesList]);

  return isOpen && list?.length > 0
    ? (
        <Lightbox
          mainSrc={list[photoIndex]}
          nextSrc={list[(photoIndex + 1) % list.length]}
          prevSrc={list[(photoIndex + list.length - 1) % list.length]}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() => {
            setPhotoIndex((photoIndex + list.length - 1) % list.length);
          }}
          onMoveNextRequest={() => {
            setPhotoIndex((photoIndex + 1) % list.length);
          }}
          onImageLoadError={() => {
            setList(picturesListFallback);
          }}
        />
      )
    : null;
};

export const usePicturesGallery = (picturesList: UrlType[]) => {
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const openGallery = (url: string) => {
    setPhotoIndex(picturesList.findIndex(p => p === url));
    setIsOpen(true);
  };
  return { isOpen, setIsOpen, photoIndex, setPhotoIndex, openGallery };
};

interface PicturesGalleryProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  photoIndex: number;
  setPhotoIndex: Dispatch<SetStateAction<number>>;
  picturesList: UrlType[];
  picturesListFallback?: UrlType[];
}
